import Button from "../../../components/ui/Button";
import Icon from "../../../components/AppIcon";

interface Service {
  id: number;
  icon: string;
  title: string;
  description: string;
  benefits: string[];
  highlight: string | null;
}

const ServicesSection = () => {
  const services: Service[] = [
    {
      id: 1,
      icon: "CreditCard",
      title: "Empréstimo Consignado",
      description:
        "Taxas especiais para aposentados e pensionistas do INSS. Desconto direto no benefício com as menores taxas do mercado.",
      benefits: [
        "Taxas a partir de 1,2% ao mês",
        "Aprovação em 24h",
        "Sem consulta ao SPC/Serasa",
      ],
      highlight: "Mais Popular",
    },
    {
      id: 2,
      icon: "Wallet",
      title: "Antecipação do FGTS",
      description:
        "Receba seu FGTS antecipado de forma rápida e segura. Ideal para quitar dívidas ou realizar sonhos.",
      benefits: [
        "Processo 100% digital",
        "Sem burocracia",
        "Liberação em até 48h",
      ],
      highlight: null,
    },
    {
      id: 3,
      icon: "Calculator",
      title: "Renegociação de Dívidas",
      description:
        "Negocie suas dívidas com condições especiais. Reduza juros e organize sua vida financeira.",
      benefits: [
        "Desconto de até 90%",
        "Parcelamento facilitado",
        "Limpa nome garantido",
      ],
      highlight: "Mais Procurado",
    },
    {
      id: 4,
      icon: "Users",
      title: "Consultoria Financeira",
      description:
        "Análise completa da sua situação financeira com plano personalizado para alcançar seus objetivos.",
      benefits: [
        "Análise gratuita",
        "Plano personalizado",
        "Acompanhamento mensal",
      ],
      highlight: null,
    },
    {
      id: 5,
      icon: "TrendingUp",
      title: "Empréstimo para CLT",
      description:
        "Crédito rápido e facilitado para trabalhadores com carteira assinada, com aprovação ágil e condições especiais.",
      benefits: [
        "Análise de crédito gratuita",
        "Parcelamento facilitado",
        "Sem Burocracia",
      ],
      highlight: "Novo",
    },
  ];

  const handleServiceClick = (serviceName: string) => {
    const message = encodeURIComponent(
      `Olá! Tenho interesse no serviço: ${serviceName}. Gostaria de mais informações.`,
    );
    window.open(`https://wa.me/553397070278?text=${message}`, "_blank");
  };

  return (
    <section id="servicos" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <div className="inline-flex items-center space-x-2 bg-primary/10 text-primary px-4 py-2 rounded-full text-sm font-medium mb-4">
            <Icon name="Star" size={16} />
            <span>Nossos Serviços</span>
          </div>

          <h2 className="text-3xl md:text-4xl font-bold text-foreground mb-4">
            Soluções Financeiras Completas
          </h2>

          <p className="text-xl text-muted-foreground max-w-3xl mx-auto">
            Oferecemos uma gama completa de serviços financeiros pensados
            especialmente para aposentados, pensionistas e trabalhadores CLT
          </p>
        </div>

        {/* Services Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services?.map((service) => (
            <div
              key={service?.id}
              className="relative bg-white border border-border rounded-2xl p-8 hover:shadow-lg transition-all duration-300 group"
            >
              {/* Highlight Badge */}
              {service?.highlight && (
                <div className="absolute -top-3 left-6 bg-primary text-primary-foreground px-3 py-1 rounded-full text-sm font-medium">
                  {service?.highlight}
                </div>
              )}

              {/* Icon */}
              <div className="w-16 h-16 bg-primary/10 rounded-2xl flex items-center justify-center mb-6 group-hover:bg-primary/20 transition-colors duration-300">
                <Icon
                  name={service?.icon as any}
                  size={32}
                  className="text-primary"
                />
              </div>

              {/* Content */}
              <div className="space-y-4">
                <h3 className="text-xl font-bold text-foreground">
                  {service?.title}
                </h3>

                <p className="text-muted-foreground leading-relaxed">
                  {service?.description}
                </p>

                {/* Benefits List */}
                <ul className="space-y-2">
                  {service?.benefits?.map((benefit, index) => (
                    <li
                      key={index}
                      className="flex items-center space-x-2 text-sm"
                    >
                      <Icon
                        name="Check"
                        size={16}
                        className="text-success flex-shrink-0"
                      />
                      <span className="text-muted-foreground">{benefit}</span>
                    </li>
                  ))}
                </ul>

                {/* CTA Button */}
                <Button
                  variant="outline"
                  fullWidth
                  onClick={() => handleServiceClick(service?.title)}
                  iconName="MessageCircle"
                  iconPosition="right"
                  className="mt-6 border-primary text-primary hover:text-white transition-colors duration-300"
                >
                  Saiba Mais
                </Button>
              </div>
            </div>
          ))}
        </div>

        {/* Bottom CTA */}
        <div className="text-center mt-16">
          <div className="bg-gradient-to-r from-primary/5 to-secondary/5 rounded-2xl p-8">
            <h3 className="text-2xl font-bold text-foreground mb-4">
              Não encontrou o que procura?
            </h3>
            <p className="text-muted-foreground mb-6 max-w-2xl mx-auto">
              Nossa equipe está pronta para criar uma solução personalizada para
              suas necessidades específicas
            </p>
            <Button
              variant="default"
              size="lg"
              onClick={() => handleServiceClick("Consultoria Personalizada")}
              iconName="MessageCircle"
              iconPosition="left"
              className="shadow-cta"
            >
              Fale com um Especialista
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ServicesSection;
